<template>
    <section class="product-section">
        <h2 class="product-section-title">Other Features</h2>
        <b-container fluid>
            <b-row>
                <b-col class="other-feature-imgwrap" cols="12" md="5" v-for="(src, index) in otherFeature" :key="index">
                    <b-img class="other-feature-img" :src="src" fluid></b-img>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    props: ['otherFeature'],
}
</script>

<style lang="scss">
    .other-feature-img{
        border: 1px solid $color-main;
        border-radius: 15px;
    }
    @media (max-width: 768px) {
        .other-feature-imgwrap:not(:last-child) {
            margin-bottom: 20px
        }
    }
</style>